import { useMemo } from 'react';
import { Delete } from 'ui/icons';
import { DeletableItemDisplayText, DeleteItemsModal } from 'ui/indexPages/modals/DeleteItemsModal';
import { useModalContext } from 'utils/contexts/modal';
import { DeleteAccountModalState } from '../types';
import { useIntegrationContext } from '../contexts/IntegrationContext';

export const testIds = {
  modal: 'mi-delete-modal',
  modalConfirmBtn: 'mi-delete-modal-confirm-btn',
};

const displayText: DeletableItemDisplayText = {
  actionName: {
    adjective: 'deleted',
    verb: 'delete',
  },
  itemTypeName: {
    singular: 'connection',
    plural: 'connections',
  },
  actionIcon: Delete,
};

export const DeleteAccountModal = () => {
  const { hideModal, modalState } = useModalContext<DeleteAccountModalState>();
  const { deleteIntegration } = useIntegrationContext();

  const onDelete = () => {
    if (modalState?.id) {
      deleteIntegration(modalState.id);
    }
    hideModal();
  };

  const content = useMemo(
    () => (modalState ? [{ id: modalState.id, name: modalState.name }] : []),
    [modalState],
  );

  return (
    <DeleteItemsModal
      data-test={testIds.modal}
      onClose={hideModal}
      onConfirm={onDelete}
      content={content}
      displayTextForContentItems={displayText}
    />
  );
};
